<section class="journey section" id="journey">
  <div class="shell-container journey__grid reveal" appRevealOnScroll="80ms">
    <div class="journey__intro">
      <div class="badge">{{ content.badge }}</div>
      <h2>{{ content.heading }}</h2>
      <p class="journey__lede">{{ content.lede }}</p>
    </div>
    <div class="journey__flow">
      <div class="journey__step" *ngFor="let step of content.steps">
        <span [class]="step.iconClass"></span>
        <div>
          <p class="journey__title">{{ step.title }}</p>
          <p class="journey__text">{{ step.text }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
